var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/hazard/custom-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/hazard/custom-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8,50.4 C22.8,56.3530273 24.7549805,62.1370117 28.3339844,66.8519531 C28.8509766,67.5339844 28.780957,68.4830078 28.1299805,69.0379883 L26.9110352,70.0780273 C26.219043,70.6669922 25.1490234,70.5830078 24.5959961,69.8620117 C20.3320312,64.2959961 18,57.4469727 18,50.4 C18,43.35 20.3320312,36.5019531 24.5980469,30.9370117 C25.1509766,30.2160156 26.2219727,30.1320313 26.9129883,30.7219727 L28.1330078,31.7629883 C28.7839844,32.3179687 28.8540039,33.2679688 28.3360352,33.9490234 C24.7549805,38.6620117 22.8,44.4469727 22.8,50.4 Z M50,28 C62.3700195,28 72.4,38.0299805 72.4,50.4 C72.4,62.7759766 62.3700195,72.8 50,72.8 C37.6299805,72.8 27.6,62.7759766 27.6,50.4 C27.6,38.0299805 37.6299805,28 50,28 Z M50.0000076,63.2 C51.7669922,63.2 53.2,61.7669922 53.2,60.0000076 C53.2,58.2330078 51.7669922,56.8 50.0000076,56.8 C48.2330078,56.8 46.8,58.2330078 46.8,60.0000076 C46.8,61.7669922 48.2330078,63.2 50.0000076,63.2 Z M52.544043,52.1589844 L53.8240234,39.3589844 C53.9179687,38.4169922 53.1790039,37.6 52.2320312,37.6 L47.7679687,37.6 C46.8209961,37.6 46.0820312,38.4169922 46.1759766,39.3589844 L47.455957,52.1589844 C47.5379883,52.9769531 48.2259766,53.6 49.0480469,53.6 L50.9519531,53.6 C51.7740234,53.6 52.4620117,52.9769531 52.544043,52.1589844 Z M75.2730469,30.7709961 C79.6209961,36.3660156 82,43.2730469 82,50.4 C82,57.530957 79.6209961,64.4379883 75.2740234,70.0320312 C74.7160156,70.75 73.644043,70.8269531 72.9570312,70.2320312 L71.7419922,69.1820312 C71.0950195,68.6219727 71.0320312,67.6730469 71.5540039,66.9950195 C75.2040039,62.2570312 77.2,56.4230469 77.2,50.4 C77.2,44.380957 75.2040039,38.5469727 71.5530273,33.8089844 C71.030957,33.130957 71.094043,32.1820313 71.7410156,31.6219727 L72.955957,30.5709961 C73.644043,29.9759766 74.7150391,30.0530273 75.2730469,30.7709961 Z",
    id: "custom-hazard",
    fill: "#1C7B97",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomIcon);
export default __webpack_public_path__ + "static/media/custom-icon.4582dfbf.svg";
export { ForwardRef as ReactComponent };